import type { CSSProperties, HTMLAttributes } from "react";
import styles from "./skeleton.module.scss";

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "text" | "circle" | "rect";
  width?: string | number;
  height?: string | number;
}

export function Skeleton({ variant = "text", width, height, className, style, ...props }: SkeletonProps) {
  const cls = [styles.skeleton, styles[variant], className ?? ""].filter(Boolean).join(" ");
  const s: CSSProperties = { ...style };
  if (width) s.width = typeof width === "number" ? `${width}px` : width;
  if (height) s.height = typeof height === "number" ? `${height}px` : height;
  return <div className={cls} style={s} aria-hidden="true" {...props} />;
}
